import React from 'react';

import Icon from '3-components/Icon/Icon';

const PropertySaleListingMapPin = props => {
    const { hit, infoWindowActive, handleInfoWindow } = props;

    return (
        <div className="map-pin-container">
            <button
                type="button"
                className="location-map-pin"
                onClick={() => (infoWindowActive ? handleInfoWindow('') : handleInfoWindow(hit.objectID))}
            >
                <img src="/assets/images/property-map-pin.png" alt="" />
            </button>
            {infoWindowActive && (
                <div className="info-window">
                    <div className="ribbon ribbon-skin-1">
                        <span className="ribbon-text">
                            For sale now
                            {hit.properties && hit.properties.length > 0 && (
                                <span className="ribbon-badge">{hit.properties.length}</span>
                            )}
                        </span>
                    </div>
                    <div className="info-title">
                        {hit.villageName}
                    </div>
                    <div className="info-address">
                        {`${hit.street ? `${hit.street}, ` : ''}${hit.suburb} ${hit.state} ${hit.postcode}`}
                    </div>
                    {hit.villageUrl && (
                        <div className="info-action">
                            <a href={hit.villageUrl} className="info-link">
                                visit
                            </a>
                        </div>
                    )}
                    <button
                        type="button"
                        className="info-close-button"
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleInfoWindow('');
                        }}
                    >
                        <Icon icon="x" />
                    </button>
                </div>
            )}
        </div>
    );
};

export default PropertySaleListingMapPin;
